//**** REACT
import React, { useLayoutEffect, useState, useContext, useEffect } from "react";
import { UsuarioContext } from "config/context/UsuarioProvider";
import { useHistory } from "react-router-dom";
// ***
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";

// *** @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import FiberManualRecord from "@material-ui/icons/FiberManualRecord";
import Checkbox from "@material-ui/core/Checkbox";
import Check from "@material-ui/icons/Check";
import Send from "@material-ui/icons/Send";
import Delete from '@material-ui/icons/Delete';
import Button from "components/CustomButtons/Button";

// *** Estilos
import featuresStyle from "assets/jss/material-kit-pro-react/views/sectionsSections/featuresStyle.js";
import basicsStyle from "assets/jss/material-kit-pro-react/views/componentsSections/basicsStyle.js";
import TextField from "@material-ui/core/TextField";
import Tooltip from "@material-ui/core/Tooltip";
// *** Services
import { PlanCompraActions } from "services";

const useStyles = makeStyles(basicsStyle);
const useStyles2 = makeStyles(featuresStyle);

export default function Periodo() {
  const history = useHistory();
  const classes = useStyles();
  const classes2 = useStyles2();
  const { usuario, setusuario, planUser, signupModalPin } = useContext(UsuarioContext);
  //funcion para ir a buscar precios a la base de datos según plan
  const [planCompra, setPlanCompra] = useState(null);
  const [helperTextDescuento, setHelperTextDescuento] = useState(
    "El campo es requerido."
  );
  const [errorDescuento, setErrorDescuento] = useState(false);

  useLayoutEffect(() => {
    var aplicaToken = false;
    if (planUser === "CFEA") {
      aplicaToken = usuario.tieneToken ? false : true;
    }
    PlanCompraActions.PlanCompra(planUser, aplicaToken).then((response) => {
      //cargar validar correo
      setPlanCompra(response.data);
    });
  }, []);
  useEffect(() => {
    if (usuario.codDescuento !== "" && usuario.codDescuento !== undefined && usuario.codDescuento !== null && planCompra != null &&
      !usuario.descuentoAplicado) {
      validaDescuento()
    }
  }, [signupModalPin.modificarData])

  useEffect(() => {
    if (usuario.descuentoAplicado) {
      eliminarDescuento()
    }
  }, [usuario.selectedEnabledPlan])

  useEffect(() => {
    if (errorDescuento) {
      limpiarDescuento()
    }
  }, [usuario.codDescuento === ""])

  function miles(val) {
    var strVal = val + "";
    return strVal.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  }
  function precioInicial(pf) {
    return miles(Math.round(pf/1.19))
  }
  function limpiarDescuento() {
    setHelperTextDescuento("")
    setErrorDescuento(false)
    setusuario({ ...usuario, codDescuento: "", descuentoAplicado: false })
  }
  function changeCheck(name) {
    if (name === "tieneToken") {
      if (usuario.tieneToken) {
        setusuario({
          ...usuario,
          selectedEnabledPlan: "1AFEACT",
          tieneToken: false,
        });
      } else {
        setusuario({
          ...usuario,
          selectedEnabledPlan: "1AFEAST",
          tieneToken: true,
        });
      }
      PlanCompraActions.PlanCompra(planUser, usuario.tieneToken).then(
        (response) => {
          setPlanCompra(response.data);
        }
      );
    }
    if (name === "esNotario") {
      if (usuario.esNotario) {
        setusuario({ ...usuario, esNotario: false });
      } else {
        setusuario({ ...usuario, esNotario: true });
      }
    }
  }
  function validaDescuento() {
    if (usuario.codDescuento === "" || usuario.codDescuento === undefined) {
      setErrorDescuento(true);
      setHelperTextDescuento("El campo es requerido.")
    } else {
      setErrorDescuento(false);
      const descuentoRequest = {};
      descuentoRequest["codigoPlan"] = usuario.selectedEnabledPlan;
      descuentoRequest["NombreDescuento"] = usuario.codDescuento;
      //ir a base de datos a preguntar si el cod es valido
      PlanCompraActions.valPlanCodDescuento(descuentoRequest).then(
        (response) => {
          if (response.data.activo === 1) {
            setusuario({ ...usuario, descuentoAplicado: true })
            setHelperTextDescuento("Descuento aplicado.")
            var results = planCompra.filter(function (plan) {
              return plan.codigo == usuario.selectedEnabledPlan
                ? (plan.valor =
                  Math.round(plan.valor - ((plan.valor * response.data.descuento) / 100)))
                : plan;
            });
            setPlanCompra(results);
            //
          } else {
            setErrorDescuento(true);
            setHelperTextDescuento(response.data.mensaje);
          }
        }
      );
    }
  }
  function eliminarDescuento() {
    var aplicaToken = false;
    if (planUser === "CFEA") {
      aplicaToken = usuario.tieneToken ? false : true;
    }
    setPlanCompra([])
    PlanCompraActions.PlanCompra(planUser, aplicaToken).then((response) => {
      limpiarDescuento()
      //cargar validar correo
      setPlanCompra(response.data);
    });
  }
  function verify_sign(kind) { // "FEA", "FES"
    if (history.location.pathname.includes("/compra/firma-token")) {
      return kind === "FEA"
    } else if (history.location.pathname.includes("/compra/firma-simple")) {
      return kind === "FES"
    } else {
      return false
    }
  }
  function titleByUrlParams() {
    if (verify_sign("FEA")) {
      return "Compra de Firma Avanzada";
    } else if (verify_sign("FES")) {
      return "Compra de Firma Simple y Certificados Tributarios";
    } else {
      return "Compra de Firma";
    }
  }
  return (
    <div>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <div className={classes.title} style={{ textAlign: (verify_sign("FEA")) ? "center" : "left", marginTop: "50px", marginBottom: "0px", }}>
            <h3 style={{width: (verify_sign("FEA")) ? "100%" : "110%", fontWeight: "400"}}>{titleByUrlParams()}</h3>
          </div>
          {planUser === "CFEA" || planUser === "CFES" ? (
            <div>
              {planUser === "CFEA" ? (
                <div className={classes.checkboxAndRadio + " " + classes.checkboxAndRadioHorizontal}>
                  <FormControlLabel control={<Checkbox tabIndex={-1} onClick={() => changeCheck("tieneToken")}
                    checked={usuario.tieneToken}
                    checkedIcon={
                      <Check className={classes.checkedIcon} />}
                    icon={
                      <Check className={classes.uncheckedIcon} />}
                    classes={{
                      checked: classes.checked,
                      root: classes.checkRoot,
                    }}
                  />
                  }
                    classes={{
                      label: classes.label.useStyles,
                      root: classes.labelRoot,
                    }}
                    label="Actualmente tengo un Token"
                  />
                </div>
              ) : null}
              <div style={{marginTop: "25px"}} className={classes.checkboxAndRadio + " " + classes.checkboxAndRadioHorizontal}>
                <div>
                  {console.log("planCompra", planCompra)}
                  {planCompra &&
                    planCompra.map((prop, key) => (
                      <FormControlLabel control={<Radio checked={usuario.selectedEnabledPlan === prop.codigo} onChange={() =>
                        setusuario({
                          ...usuario,
                          selectedEnabledPlan: prop.codigo,
                        })
                      }
                        value="a"
                        name="radio button enabled"
                        aria-label="A"
                        icon={
                          <FiberManualRecord className={classes.radioUnchecked} />
                        }
                        checkedIcon={
                          <FiberManualRecord className={classes.radioChecked} />
                        }
                        classes={{
                          checked: classes.radio,
                          root: classes.radioRoot,
                        }}
                      />
                      }
                        classes={{
                          label: classes.label.useStyles,
                          root: classes.labelRoot,
                        }}
                        label={
                          usuario.descuentoAplicado && usuario.selectedEnabledPlan === prop.codigo
                            // ? <h5 style={{ color: "#a1c330", fontWeight: 600 }}> {prop.duracionProducto + "($" + miles(prop.valor) + ")"} </h5>
                            // : prop.duracionProducto + "($" + miles(prop.valor) + ")"
                            ? <div>
                                <span style={{ color: "#a1c330", fontWeight: 600 }}>{prop.duracionProducto + " = $" + miles(prop.valor) }</span>
                                <div style={{ position: "absolute", top: "-12px", fontSize: "small" }}>{ "(Valor = " + precioInicial(prop.valor) + "+IVA)" }</div>
                              </div>
                            : <div>
                                <span style={{ fontWeight: 600 }}>{prop.duracionProducto + " = $" + miles(prop.valor)}</span>
                                <div style={{ position: "absolute", top: "-12px", fontSize: "small" }}>{ "(Valor = " + precioInicial(prop.valor) + "+IVA)" }</div>
                              </div>
                        }
                      />
                    ))}
                </div>
              </div>              
              <GridContainer>
                <GridItem xs={12} sm={12} md={4}>
                  <TextField fullWidth id="txtCodigo" label="Código de descuento" value={usuario.codDescuento}
                    disabled={usuario.descuentoAplicado} onChange={(e) =>
                      setusuario({ ...usuario, codDescuento: e.target.value })
                    }

                    error={errorDescuento}
                    helperText={errorDescuento || usuario.descuentoAplicado ? <h8 style={{
                      color:
                        errorDescuento ? "" : "#a1c330"
                    }}>{helperTextDescuento}</h8> : ""}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={6} style={{ paddingLeft: "0px" }}>
                  {
                    usuario.descuentoAplicado ?
                      <Tooltip title="Eliminar descuento">
                        <Button size="sm" color="danger" style={{ margin: "20px 0px 0px 2px", padding: "5px" }} onClick={(e) =>
                          eliminarDescuento()}
                          className={classes.actionButton}
                        >
                          <Delete className={classes.icon} style={{ marginRight: "0px" }} />
                        </Button>
                      </Tooltip>
                      :
                      <Tooltip title="Aplicar">
                        <Button size="sm" style={{ backgroundColor: "#a1c330", margin: "20px 0px 0px 2px", padding: "5px" }}
                          onClick={(e) => validaDescuento()}
                          className={classes.actionButton}
                        >
                          <Send className={classes.icon} style={{ marginRight: "0px" }} />
                        </Button>
                      </Tooltip>
                  }


                </GridItem>
              </GridContainer>
            </div>
          ) : null}
        </GridItem>
      </GridContainer>
    </div>
  );
}
